import request from '@/api/config.js'

/**
 * Получить настройки формы для организации (админский роут)
 * @param {number|string} orgId - ID организации
 * @returns {Promise} Promise с настройками формы
 */
export function getFormSettings(orgId) {
  return request({
    url: `custom-form/settings/${orgId}`,
    method: 'get',
  })
}

/**
 * Сохранить настройки формы для организации
 * @param {Object} data - Данные настроек { orgId, settings }
 * @returns {Promise} Promise с обновленными настройками
 */
export function saveFormSettings(data) {
  return request({
    url: 'custom-form/settings',
    method: 'put',
    data,
  })
}

/**
 * Обновить кастомное поле (название)
 * @param {number} fieldId - ID поля
 * @param {string} label - Новое название поля
 * @returns {Promise} Promise с обновленным полем
 */
export function updateCustomField(fieldId, label) {
  return request({
    url: `custom-form/fields/${fieldId}`,
    method: 'patch',
    data: { label },
  })
}

/**
 * Создать кастомное поле для организации
 * @param {Object} data - Данные поля { orgId, label, entity }
 * @returns {Promise} Promise с обновленными настройками
 */
export function createCustomField(data) {
  return request({
    url: 'custom-form/fields',
    method: 'post',
    data,
  })
}

/**
 * Удалить кастомное поле для организации
 * @param {Object} data - Данные удаления { orgId, fieldId }
 * @returns {Promise} Promise с обновленными настройками
 */
export function deleteCustomField(data) {
  return request({
    url: `custom-form/fields/${data.fieldId}`,
    method: 'delete',
    data: { orgId: data.orgId },
  })
}

/**
 * Получить конфигурацию формы для страницы записи (публичный роут)
 * @param {number|string} departmentId - ID филиала
 * @returns {Promise} Promise с конфигурацией формы
 */
export function getFormConfig(departmentId) {
  return request({
    url: `custom-form/config/${departmentId}`,
    method: 'get',
  })
}

/**
 * Получить конфигурацию формы для организации (приватный роут)
 * @param {number|string} orgId - ID организации
 * @returns {Promise} Promise с конфигурацией формы
 */
export function getFormConfigByOrg(orgId) {
  return request({
    url: `custom-form/config/org/${orgId}/client-form-config`,
    method: 'get',
  })
}

/**
 * Получить значения кастомных полей для клиента и/или автомобиля
 * @param {Object} params - { clientId, carId }
 * @returns {Promise} Promise с значениями формы
 */
export function getFormValues(params = {}) {
  return request({
    url: 'custom-form/values',
    method: 'get',
    params,
  })
}
